import { IReportNhapHocRequest } from "../../../model/request/report/IReportNhapHocRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportNhapHocRespone } from "../../../model/respone/report/IReportNhapHocRespone";
import { IReportNhapHocActionTypes } from "../../action-types/report/IReportNhapHocActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IReportNhapHocReducer } from "../../reducer-model/report/IReportNhapHocReducer";

const iniState: IReportNhapHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  filerModeReport: "all-co-cong-no",
  filerModeSinhVien: "all",
  isShowFilter: false,
  reports: {} as IPagingResult<IReportNhapHocRespone[]>,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_hes: [],
    dot_nhap_hocs: [],
    id_chuyen_nganhs: [],
    nam_nhap_hoc: 0,
    id_nganhs: [],
    id_thu_chis: [],
    is_co_cong_no: false,
    search_key: "",
    ghi_chu: "",
    trang_thai_nop_tien: "all",
    trang_thai_nhap_hoc: "all",
    mau_so: "",
    page_index: 0,
    page_size: 100,
    id_hinh_thuc_thus: [],
  } as IReportNhapHocRequest,
};
export const reportNhapHocReducer = (
  state: IReportNhapHocReducer = iniState,
  action: IReportNhapHocActionTypes,
): IReportNhapHocReducer => {
  switch (action.type) {
    case "REPORT_NHAP_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "REPORT_NHAP_HOC_LOAD_SUCCESS":
      return {
        ...state,
        reports: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_NHAP_HOC_LOAD_ERROR":
      return {
        ...state,
        reports: {} as IPagingResult<IReportNhapHocRespone[]>,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_NHAP_HOC_CHANGE_REPORT_FILTER":
      return {
        ...state,
        filerModeReport: action.payload,
        status:
          state.request.is_co_cong_no && action.payload === "all"
            ? eReducerStatusBase.is_need_reload
            : state.status,
        request: {
          ...state.request,
          is_co_cong_no: action.payload !== "all",
        },
      };
    case "REPORT_NHAP_HOC_CHANGE_REQUEST": {
      // Chỉ paging mới auto-reload. Filter/search/sort/scope yêu cầu "Làm mới".
      const reloadKeys = ["page_index", "page_size"];
      const keys = Object.keys(action.payload);
      const isReload = keys.length > 0 && keys.every((k) => reloadKeys.includes(k));
      return {
        ...state,
        ...(isReload && {
          reports: {} as IPagingResult<IReportNhapHocRespone[]>,
          status: eReducerStatusBase.is_need_reload,
        }),
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    }
    case "REPORT_NHAP_HOC_CHANGE_SINHVIEN_FILTER":
      return {
        ...state,
        filerModeSinhVien: action.payload,
      };
    case "REPORT_NHAP_HOC_SHOW_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: true,
        idSinhVien: action.payload,
      };
    case "REPORT_NHAP_HOC_CLOSE_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: false,
      };
    case "REPORT_NHAP_HOC_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "REPORT_NHAP_HOC_EXPORT_EXCEL_BAO_CAO_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "REPORT_NHAP_HOC_EXPORT_EXCEL_BAO_CAO_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "REPORT_NHAP_HOC_EXPORT_EXCEL_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
